import { Center, Loader, Stack, Text } from '@mantine/core';

export function Loading({ label = 'Loading…' }) {
  return <Center p="xl"><Stack align="center" gap="sm"><Loader size="sm" /><Text size="sm" c="dimmed" role="status">{label}</Text></Stack></Center>;
}
